export default "__VITE_ASSET__d64f529e__"